export class Password
{
    storeid: string;  
    currentpassword: string;
    password: string;
    confirmpassword: string;
}


// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/passwordmodel.ts